import {
  ChannelTypeInternal,
  BinarySensorChannelStateResponse,
  UserChannel,
  BinarySensorTypeInternal,
  BinarySensorChannelStateResponseFragment,
} from '../../../../../data-access/gql-types/graphql';
import { ChannelIconTypeEnum } from '../../../../../types';
import { ChannelBinarySensorStateType, ChannelType } from '../../../types';

export const parseBinarySensorChannel = (userChannel: UserChannel): ChannelType => {
  const channelPayload = userChannel.payload as
    | (BinarySensorChannelStateResponse & BinarySensorChannelStateResponseFragment)
    | undefined;

  return {
    id: userChannel.id,
    installationId: userChannel.installationId,
    isVisible: userChannel.isVisible,
    alias: userChannel.alias,
    iconName: userChannel.iconName || ChannelIconTypeEnum.SENSOR,
    deviceId: userChannel.deviceId,
    currentFirmwareVersion: userChannel.currentFirmwareVersion || null,
    data: {
      type: ChannelTypeInternal.BinarySensor,
      groupType: ChannelTypeInternal.Sensor,
      sensorType: channelPayload?.binarySensorType || BinarySensorTypeInternal.Unknown,
    },
  };
};

export const parseBinarySensorChannelState = (userChannel: UserChannel): ChannelBinarySensorStateType => {
  const channelPayload = userChannel.payload as
    | (BinarySensorChannelStateResponse & BinarySensorChannelStateResponseFragment)
    | undefined;

  return {
    deviceConnectionState: channelPayload?.deviceConnectionState,
    value: channelPayload?.binarySensorValue,
  };
};
